var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    ref: "ruleForm",
    staticClass: "form",
    attrs: {
      model: _vm.form,
      rules: _vm.rules,
      "label-col": {
        span: 2
      },
      "wrapper-col": {
        span: 12
      },
      disabled: !_vm.isEdit
    }
  }, [_c("a-form-model-item", {
    staticClass: "upload",
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      label: _vm.$t("设置icon"),
      prop: "icon"
    }
  }, [_c("a-upload", {
    attrs: {
      action: _vm.action,
      "list-type": "picture-card",
      "file-list": _vm.fileList,
      accept: "image/*",
      "before-upload": _vm.beforeUpload,
      data: {
        module: "dynamicControls"
      },
      showUploadList: {
        showRemoveIcon: true,
        showPreviewIcon: true
      },
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      },
      disabled: !_vm.isEdit
    },
    on: {
      change: function ($event) {
        return _vm.handleChange($event);
      },
      preview: _vm.previewImg
    }
  }, [_vm.fileList.length == 0 ? _c("div", [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _c("div", {
    staticClass: "ant-upload-text"
  }, [_vm._v(_vm._s(_vm.$t("上传")))])], 1) : _vm._e()])], 1), _c("div", {
    staticClass: "tips"
  }, [_vm._v(" *" + _vm._s(_vm.$t("仅支持上传jpg,jpeg,png格式图片，图片大小不超500KB")) + " "), _c("br"), _vm._v(" *" + _vm._s(_vm.$t("图片将作为客户系统页面中联系方式图标展示")) + " ")]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("文案设置"),
      prop: "copyWriting"
    }
  }, [_c("a-textarea", {
    staticClass: "textarea",
    attrs: {
      placeholder: _vm.$t("请输入文案设置"),
      rows: 7,
      maxLength: 255,
      disabled: !_vm.isEdit
    },
    on: {
      blur: function ($event) {
        return _vm.handleBlurTrim("copyWriting");
      }
    },
    model: {
      value: _vm.form.copyWriting,
      callback: function ($$v) {
        _vm.$set(_vm.form, "copyWriting", $$v);
      },
      expression: "form.copyWriting"
    }
  })], 1), _c("div", {
    staticClass: "btnhandles"
  }, [_vm.btnShow === 1 || _vm.isEdit === true ? _c("a-button", {
    attrs: {
      type: "primary",
      disabled: _vm.disableBtn
    },
    on: {
      click: _vm.saveForm
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))]) : _vm._e(), _vm.btnShow === 2 && _vm.isEdit === false ? _c("a-button", {
    attrs: {
      type: "edit"
    },
    on: {
      click: _vm.editForm
    }
  }, [_vm._v(_vm._s(_vm.$t("编辑")))]) : _vm._e(), _vm.btnShow === 3 && _vm.isEdit === true ? _c("a-button", {
    on: {
      click: _vm.cancelForm
    }
  }, [_vm._v(_vm._s(_vm.$t("取消")))]) : _vm._e()], 1)], 1), _c("a-modal", {
    attrs: {
      visible: _vm.previewVisible,
      footer: null
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  }, [_c("img", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      alt: "example",
      src: _vm.previewSrc
    }
  })])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };